const SIZE_TOKENS =
  "XS|S|SM|SMALL|M|MD|MEDIUM|L|LG|LARGE|XL|X-LARGE|XXL|2X|3X";

export function parseVariantDisplayName(displayName) {
  const raw = String(displayName ?? "").trim();
  if (!raw) return { color: "", size: "" };

  const spacedDashMatch = raw.match(/\s+[\u2013\u2014-]\s+/);
  if (spacedDashMatch?.index != null) {
    return {
      color: raw.slice(0, spacedDashMatch.index).trim(),
      size: raw.slice(spacedDashMatch.index + spacedDashMatch[0].length).trim(),
    };
  }

  const slashSizeSplit = raw.match(
    new RegExp(`^(.*?)\\/\\s*(${SIZE_TOKENS}|X)\\b`, "i")
  );
  if (slashSizeSplit) {
    const left = slashSizeSplit[1] || "";
    return { color: left.trim(), size: raw.slice(left.length + 1).trim() };
  }

  const compactSizeSplit = raw.match(
    new RegExp(`^(.*?)-\\s*(${SIZE_TOKENS})\\b`, "i")
  );
  if (compactSizeSplit) {
    const left = compactSizeSplit[1] || "";
    return { color: left.trim(), size: raw.slice(left.length + 1).trim() };
  }

  const parts = raw.split("-");
  return {
    color: String(parts[0] ?? "").trim(),
    size: parts.slice(1).join("-").trim(),
  };
}

// Prefers the explicit sizeName from the API: the color is whatever precedes
// it in displayName. Falls back to parsing displayName alone when sizeName is
// null or displayName does not end in it.
export function resolveVariantColorAndSize(variant) {
  const raw = String(variant?.displayName ?? "").trim();
  const sizeName = String(variant?.sizeName ?? "").trim();

  if (raw && sizeName && raw.toLowerCase().endsWith(sizeName.toLowerCase())) {
    const color = raw
      .slice(0, raw.length - sizeName.length)
      .replace(/[\s\u2013\u2014/-]+$/, "")
      .trim();
    if (color) return { color, size: sizeName };
  }

  return parseVariantDisplayName(raw);
}

// variationId is one color in the data model, so it is the grouping key; the
// parsed label is only display text and the fallback key.
export function getVariantColorKey(variant, colorLabel) {
  return variant?.variationId != null && variant.variationId !== ""
    ? `v:${variant.variationId}`
    : `l:${colorLabel}`;
}
